import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../../../theme';
import Money, { MoneyType } from '../../../../../../Money';
import { SelectedOrderServiceStatus } from '@entities/order';
import { CdnIcon, CdnIconNames } from '@shared/ui';

const ICON_NAME_MAP: Partial<Record<SelectedOrderServiceStatus, CdnIconNames>> = {
	confirmed: 'Info/Item Icluded',
	unconfirmed: 'Info/Details'
};

interface Props {
	icon?: CdnIconNames;
	label: React.ReactNode;
	status: SelectedOrderServiceStatus;
	price?: MoneyType;
	isLoading?: boolean;
	onDelete?: () => void;
}

const CardExtraSummaryItem: React.FC<Props> = ({ icon, label, status, price, isLoading, onDelete }) => {
	const { CardExtraSummaryItem: theme } = useTheme('Shared').CardExtraView;

	const isRequested = status === 'requested';
	const isConfirmed = status === 'confirmed';
	const isUnconfirmed = status === 'unconfirmed';

	const statusIcon = ICON_NAME_MAP[status];

	return (
		<>
			<div
				className={cn(theme.root, {
					[theme.root_requested]: isRequested,
					[theme.root_confirmed]: isConfirmed,
					[theme.root_unconfirmed]: isUnconfirmed
				})}
			>
				<div className={theme.label}>
					{icon && (
						<div className={theme.icon}>
							<CdnIcon icon={icon} />
						</div>
					)}
					<span>{label}</span>
				</div>
				<div className={theme.info}>
					{!!statusIcon ? (
						<div className={theme.icon}>
							<CdnIcon icon={statusIcon} />
						</div>
					) : (
						<>
							{price && <Money money={price} />}
							{onDelete && !isRequested && (
								<div className={theme.button_delete} onClick={onDelete}>
									<CdnIcon icon="Action/Close-Clear" />
								</div>
							)}
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default CardExtraSummaryItem;
